var Order = function (data) {
    var self = this;

    this.order_id = data.order_id;
    this.bulk_order_id = data.bulk_order_id;
    this.po_number = data.po_number;
    this.is_invoiced = data.is_invoiced;

    this.search = function (query) {
        var regex = new RegExp(query, 'i');

        if (self.order_id && self.order_id.search(regex) != -1) return true;
        if (self.po_number.search(regex) != -1) return true;
        if (self.is_invoiced && 'download'.search(regex) != -1) return true;

        return false;
    };
};

module.exports = Order;


//////////////////
// WEBPACK FOOTER
// ../textbookx/service/bulk_po/scripts/ExistingOrders/Order.js
// module id = 22
// module chunks = 0